/**
 * What kind of room it is, said once. The Rooms list, Conversations' rail, search, a room's groups and the guest's
 * sessions all read this, so a room is never "Weekly" in one place and "Plays any time" in another.
 */
export type RoomKind = "Weekly" | "Plays any time" | "One-time";

/** `hasSeries`: the room has a series of live sessions (a live_series row, or the list's `live.series`). */
export function roomKindOf(scheduleMode: string, hasSeries: boolean): RoomKind {
  if (scheduleMode === "recurring") return "Weekly";
  if (scheduleMode === "live") return hasSeries ? "Weekly" : "One-time";
  if (scheduleMode === "one_time") return "One-time";
  return "Plays any time";
}
